module.exports = __webpack_public_path__ + "static/uniqa-747a8c8b0b2beca4852ac430021167f8.svg";